import React from 'react'
import { Trans } from 'react-i18next'
import { MaluLogoImage, RightContentWrapper, TextCopyright, TextCopyrightLink } from './FooterRightContent.styled'
import maluLogo from '../../../assets/images/malu-white.png'
import { FooterSeparator } from '../Footer.styled'

const FooterRightContent: React.FC = () => {
  return (
    <RightContentWrapper>
      <MaluLogoImage alt="malu Logo" src={maluLogo} />
      <TextCopyright sx={{ whiteSpace: 'pre-wrap' }}>
        <Trans
          i18nKey="footer.copyright"
          shouldUnescape={true}
          components={{
            belma: (
              <>
                <TextCopyrightLink href="https://belma.gr" target="_blank" rel="noopener noreferrer">
                  Belma
                </TextCopyrightLink>
                &nbsp;
                <FooterSeparator orientation="vertical" component="span" flexItem />
              </>
            ),
          }}
        />
      </TextCopyright>
    </RightContentWrapper>
  )
}

export default FooterRightContent
